/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AddCollaboratorNotFoundErrorCode = (typeof AddCollaboratorNotFoundErrorCode)[keyof typeof AddCollaboratorNotFoundErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddCollaboratorNotFoundErrorCode = {
  agent_not_found: "agent_not_found",
} as const;
